import TicketCreateRecommendations from './TicketCreateRecommendations';

export default TicketCreateRecommendations;
